import { Injectable } from '@angular/core';
import LogRocket from 'logrocket';

@Injectable({
  providedIn: 'root',
})
export class LoggingService {
  private sessionUrl = '';

  constructor() {}

  setSessionUrl() {
    LogRocket.getSessionURL((sessionURL) => {
      this.sessionUrl = sessionURL;
    });
  }

  getSessionUrl(): string {
    if (this.sessionUrl === '') {
      this.setSessionUrl();
    }
    return this.sessionUrl;
  }
}
